import { FC } from 'react';

import Link from 'next/link';

import { DateTime } from 'luxon';

import { SaleCaseItem } from '@type-def_iqfu/public/SaleCaseItem';

import { MonthOutputFormat } from '@constants_iqfu';

import styles from './SaleCaseTable.module.scss';

type Props = {
  saleCasesData: SaleCaseItem[];
  pageLabel: string;
  readMoreButtonClicked: boolean;
  showCompanyName?: boolean;
  onlyPurchaseSaleCases: boolean;
};

const MansionSaleCaseTable: FC<Props> = ({
  saleCasesData,
  pageLabel,
  readMoreButtonClicked,
  showCompanyName,
  onlyPurchaseSaleCases,
}) => {
  return (
    <div
      className={`${styles.saleCase_table_container} ${styles.mansion_table_container}
      ${showCompanyName ? '' : styles.without_companyName}
      ${onlyPurchaseSaleCases ? styles.without_price : ''}
    `}
    >
      <div className={`${styles.saleCase_table} ${readMoreButtonClicked ? styles.isScrollable : ''}`}>
        <div className={styles.table_head_row}>
          <div className={styles.table_cell}>成約年月</div>
          <div className={styles.table_cell}>マンション名</div>
          {showCompanyName && <div className={styles.table_cell}>不動産会社</div>}
          {!onlyPurchaseSaleCases && <div className={styles.table_cell}>成約価格</div>}
          <div className={styles.table_cell}>階数</div>
          <div className={styles.table_cell}>専有面積</div>
        </div>
        <div className={styles.table_data_container}>
          {saleCasesData.map((data: SaleCaseItem, i: number) => {
            return (
              <div key={i} className={styles.table_data_row}>
                <div className={styles.table_cell}>
                  {DateTime.fromISO(data.contract_date).toFormat(MonthOutputFormat)}
                </div>

                <div className={styles.table_cell}>
                  <Link prefetch={false} href={`/mansions/${data.mansion_id}`}>
                    {data.mansion_name}
                  </Link>
                </div>

                {showCompanyName && (
                  <div className={styles.table_cell}>
                    <Link prefetch={false} href={`/companies/${data.company_id}`}>
                      {data.display_name}
                    </Link>
                  </div>
                )}
                {data.price && (
                  <div className={`${styles.table_cell} ${styles.table_cell_price}`}>
                    {data.price.toLocaleString()}万円
                  </div>
                )}
                <div className={styles.table_cell}>{data.floor}階</div>
                <div className={styles.table_cell}>
                  <>{data.property_type === 'mansion' && data.occupied_area && <span>{data.occupied_area} ㎡</span>}</>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MansionSaleCaseTable;
